import React from "react";
import { Scrollbars } from "react-custom-scrollbars";

const CustomScrollbars = ({ hideHorizontalScroll = false, ...props }) => (
  <Scrollbars
    {...props}
    autoHide
    renderTrackHorizontal={(props) => (
      <div
        {...props}
        style={{ display: "none" }}
        className="track-horizontal"
      />
    )}
    {...(hideHorizontalScroll && {
      renderView: (viewProps) => (
        <div
          {...viewProps}
          style={{ ...viewProps.style, overflowX: "hidden" }}
        />
      ),
    })}
  />
);

export default CustomScrollbars;
